import React from 'react';
import Blogimg from "../../../Assets/Blog/blogmainimage.png";
import Blogimgone from "../../../Assets/Blog/blogone.png";
import Blogimgtwo from "../../../Assets/Blog/blogtwo.png";
import Blogimgthree from "../../../Assets/Blog/blog.png";
import { assets } from '../../../Assets/assets';
import { Link } from 'react-router-dom';
const BlogDetails = ({ blog }) => {
    return (
        <div className=" bg-gray-50">
            {/* Main Content */}
            <main className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* Blog Content */}
                    <div data-aos="fade-up" data-aos-duration="1000" className="lg:col-span-2">
                        {/* Featured Image */}
                        <div data-aos="fade-up" data-aos-duration="1000" className="overflow-hidden mb-6">
                            <img
                                src={Blogimg}
                                alt="Team collaboration"
                                className="w-full h-64 sm:h-80 object-cover"
                            />
                        </div>

                        {/* Article Metadata */}
                        <div className="">
                            <div data-aos="fade-up" data-aos-duration="1000" className="flex items-center text-sm text-gray-500 mb-4">
                                <span>{blog?.date}</span>
                                <span className="mx-2">•</span>
                                <div className='space-x-3'>
                                    {
                                        blog?.category?.map((c, index) => (
                                            <span className='bg-primaryFadedColor text-white px-3 py-1.5 rounded-md' key={index}>{c}</span>
                                        ))
                                    }
                                </div>
                            </div>

                            {/* Article Title */}
                            <h1 data-aos="fade-up" data-aos-duration="1000" className="text-3xl sm:text-4xl font-semibold font-SpaceGrotesk text-primaryColor mb-6">
                                {blog?.title}
                            </h1>

                            {/* Article Content */}
                            <div className="prose max-w-none">
                                {
                                    blog?.content?.slice(0, 3).map((c, idx) => (
                                        <p data-aos="fade-up" data-aos-delay={`${idx * 100}`} key={idx} className="text-gray-700 leading-relaxed mb-6">
                                            {c}
                                        </p>
                                    ))
                                }

                                {/* Quote Block */}
                                <div className="bg-blue-50 border-l-4 border-blue-500 p-6 my-8">
                                    <p data-aos="fade-up" data-aos-duration="1000" className="text-lg text-gray-800 italic">
                                        {blog?.quote}
                                    </p>
                                </div>

                                {
                                    blog?.content?.slice(3).map((c, idx) => (
                                        <p data-aos="fade-up" data-aos-delay={`${idx * 100}`} key={idx} className="text-gray-700 leading-relaxed mb-6">
                                            {c}
                                        </p>
                                    ))
                                }

                                {/* Image Grid */}
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                                    <img data-aos="fade-up" data-aos-delay="100"

                                        src={Blogimgone}
                                        alt="Team meeting"
                                        className="w-full h-48 object-cover rounded-lg"
                                    />
                                    <img data-aos="fade-up" data-aos-delay="200"

                                        src={Blogimgtwo}
                                        alt="Working on laptop"
                                        className="w-full h-48 object-cover rounded-lg"
                                    />
                                    <img data-aos="fade-up" data-aos-delay="300"

                                        src={Blogimgthree}
                                        alt="Design work"
                                        className="w-full h-48 object-cover rounded-lg"
                                    />
                                </div>

                                {/* Section Heading */}
                                <h2 data-aos="fade-up" data-aos-duration="1000" className="text-2xl font-semibold font-SpaceGrotesk text-primaryColor mb-4">
                                    {blog?.section2Title}
                                </h2>
                                {
                                    blog?.section2Content?.slice(0, 3).map((c, idx) => (
                                        <p data-aos="fade-up" data-aos-duration="1000" key={idx} className="text-gray-700 leading-relaxed mb-6">
                                            {c}
                                        </p>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                    {/* Sidebar */}
                    <div data-aos="fade-up" data-aos-duration="1000" className="lg:col-span-1 rounded-md bg-gradient-to-br from-indigo-900 to-purple-900 h-fit sticky top-32">
                        {/* Call to Action Card */}
                        <div style={{ backgroundImage: `url(${assets.servicebg})` }} className="rounded-lg flex flex-col justify-center sticky top-32 h-full items-center shadow-lg p-8 w-full text-center bg-right-bottom text-white">
                            <img src={assets.logo} alt="logo" className='w-[10rem]' />
                            <div className="text-xl font-bold mb-2">myWebsite</div>
                            <h3 className="text-2xl font-bold mb-6">Let`s Build Your Website</h3>
                            <Link to={'/contactus'} className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-8 rounded-lg w-full inline-block transition duration-200">
                                Get Started
                            </Link>
                        </div>

                    </div>
                </div>
            </main>

        </div>
    );
};

export default BlogDetails;